export default __webpack_public_path__ + "9fbf47d211912650ced0137f95b791fa.glb";